import React, { useCallback, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore, isMobile } from '@pascal/pascal-core';
import { autoPlayBetStore, gameStore, inputValidationStore } from '../../../../store';
import {
  betInputPlusOrMinus,
  GameResponseTypeName,
  globalTranslationKeys,
  numPadTypes,
  onWinEnum,
} from '../../../../enums';
import { useAmountValidation, handlePlusMinusValue } from '../../../../helpers';

const prefix = 'x';

export const WinLossBaseBetIncrease = observer(({ t, marketName, handleOpenNumPad }) => {
  const title =
    marketName === onWinEnum ? t(globalTranslationKeys.OnWin) : t(globalTranslationKeys.OnLoss);
  const { [marketName]: increaseMarket } = autoPlayBetStore.autoPlayData;
  const { limits } = gameConfigStore;
  const { minOdd } = gameStore;

  const increaseOddParams = {
    storeValue: increaseMarket.increaseOdd,
    minValue: minOdd,
    maxValue: limits.maxWin / limits.minBet,
    incDec: 1,
  };
  const handleChangeIncrease = useCallback(({ changeValue, propName }) => {
    autoPlayBetStore.setOnWinLossIncreaseValue(changeValue, propName);
  }, []);
  const [isFocused, setIsFocused] = useState(false);
  const { onChange: onChangeIncrease } = useAmountValidation(handleChangeIncrease);

  const handleDecIncIncreaseOdd = (actionType, marketName) => {
    const changedOddValue = handlePlusMinusValue(actionType, increaseOddParams);

    autoPlayBetStore.setOnWinLossIncreaseValue(changedOddValue, marketName);
  };

  const setIsIncreaseState = (bool, marketName) => {
    autoPlayBetStore.setIsIncreaseState(bool, marketName);
  };

  const increaseOnBlur = (e) => {
    inputValidationStore.setDefaultValue(
      e.target?.value.trim(),
      autoPlayBetStore.setOnWinLossIncreaseValue,
      increaseOddParams,
      marketName,
      GameResponseTypeName.OnInc
    );
  };

  return (
    <div className='sec-row-inner-bl'>
      <p className='small-text' title={title}>
        {title}
      </p>
      <div className='auto-bet-block'>
        <div className='auto-bet-bl-inner'>
          <div className='auto-bet-type-box'>
            <div className='auto-bet-type' onClick={() => setIsIncreaseState(false, marketName)}>
              <label className='bet-type-checkbox-bl'>
                <input
                  type='checkbox'
                  checked={!increaseMarket.isIncrease}
                  className='bet-type-checkbox'
                  onChange={() => {}} // todo this case must be handled in second  or third commit
                />
                <span className='bet-type-checkbox-item' />
              </label>
              <p title={t(globalTranslationKeys.BaseBet)} className='small-text'>
                {t(globalTranslationKeys.BaseBet)}
              </p>
            </div>
            <div className='auto-bet-type' onClick={() => setIsIncreaseState(true, marketName)}>
              <label className='bet-type-checkbox-bl'>
                <input
                  type='checkbox'
                  checked={increaseMarket.isIncrease}
                  className='bet-type-checkbox'
                  onChange={() => {}} // todo this case must be handled in second  or third commit
                />
                <span className='bet-type-checkbox-item' />
              </label>
              <p title={t(globalTranslationKeys.Increase)} className='small-text'>
                {t(globalTranslationKeys.Increase)}
              </p>
            </div>
          </div>
          <div className={`bet-inpt-box small ${!increaseMarket.isIncrease ? 'disabled' : ''}`}>
            <div className='bet-inpt-box-inner '>
              <div
                className={`bet-inpt-rulers ${
                  increaseMarket.increaseOdd <= increaseOddParams.minValue ? 'disabled' : ''
                }`}
                onClick={() => handleDecIncIncreaseOdd(betInputPlusOrMinus.minus, marketName)}
              >
                <span className=' ui-lib-minus' />
              </div>
              <input
                className='bet-opt-inp'
                type='text'
                maxLength='9'
                inputMode='none'
                value={
                  !isFocused ? prefix + increaseMarket.increaseOdd : increaseMarket.increaseOdd
                }
                onChange={(e) => onChangeIncrease(e, marketName)}
                onFocus={() => setIsFocused(true)}
                onBlur={(e) => {
                  setIsFocused(false);
                  increaseOnBlur(e);
                }}
                {...(isMobile()
                  ? {
                      onClick: (e) =>
                        handleOpenNumPad(
                          e,
                          numPadTypes.winLossIncrease,
                          marketName,
                          increaseOddParams
                        ),
                    }
                  : {})}
              />
              <div
                className={`bet-inpt-rulers   ${
                  increaseMarket.increaseOdd >= increaseOddParams.maxValue ? 'disabled' : ''
                }`}
                onClick={() => handleDecIncIncreaseOdd(betInputPlusOrMinus.plus, marketName)}
              >
                <span className=' ui-lib-plus' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
